export function syncSectionDiagram(variants, fallbacks, count) {
  let drawn = false

  variants.forEach((element) => {
    const matches = Number(element.dataset.sections) === count
    drawn ||= matches
    element.classList.toggle("hidden", !matches)
  })

  fallbacks.forEach((element) => {
    element.classList.toggle("hidden", drawn)
  })
}
